// This experimental media query attempts to target touch devices for mobile style. A bug was noticed where landscape mobile devices incorrectly displayed desktop styles for the avatar component in user settings. This new media query is currently only used in the avatar component to prevent wider unintended changes to mobile web styling.
import { css } from 'styled-components'
const mobileQuery = `(max-width: 767px), (hover: none) and (pointer: coarse)`
const desktopQuery = `(min-width: 768px)`
export const mobile = {
    query: mobileQuery,
    css: (...args) => css`
        @media ${mobileQuery} {
            ${css(...args)};
        }
    `,
}
export const desktop = {
    query: desktopQuery,
    css: (...args) => css`
        @media ${desktopQuery} {
            ${css(...args)};
        }
    `,
}
